(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsNewVendorDueDiligenceDocumentController', CmsNewVendorDueDiligenceDocumentController);

  /* ngInject */
  function CmsNewVendorDueDiligenceDocumentController($state, Flash, cmsVendorDueDiligenceDocumentService, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.vendorDueDiligenceDocument = {};
    vm.vendorDueDiligenceDocumentForm = {};
    vm.createVendorDueDiligenceDocument = createVendorDueDiligenceDocument;

    activate();

    function activate() {}

    function createVendorDueDiligenceDocument(vendorDueDiligenceDocument) {
      vm.clearFormErrors();
      cmsVendorDueDiligenceDocumentService(sessionService.getAuthToken()).save(vendorDueDiligenceDocument, _createVendorDueDiligenceDocumentSuccess, _createVendorDueDiligenceDocumentFailure);
    }

    function _createVendorDueDiligenceDocumentSuccess(response) {
      Flash.create('success', 'The vendor due diligence document was successfully created.');
      $state.go('application.compliance_services.cms_edit_vendor_due_diligence_document', {id: response.id});
    }

    function _createVendorDueDiligenceDocumentFailure(response) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the errors below and resubmit.');
      vm.setFormErrors(vm.vendorDueDiligenceDocumentForm, response);
    }
  }
})();
